import React from "react";
import { StyledVerbalizeNowIcon } from "./style";
import VerbalizeNowLogo from "./assets/logo-verbalize-now.png";

const URL = "https://portal.verbalizenow.com/login";

interface IProps {
  isAllowed: boolean;
}

const VerbalizeNowIcon = ({ isAllowed }: IProps): JSX.Element => (
  <>
    {isAllowed && (
      <StyledVerbalizeNowIcon>
        <a href={URL} target="_blank" rel="noreferrer">
          <img src={VerbalizeNowLogo} alt="Verbalize Now Logo" />
        </a>
      </StyledVerbalizeNowIcon>
    )}
  </>
);

export default VerbalizeNowIcon;
